import { createGetOptionsFn } from '@common/selectOptions.services';
import { IProjectTwcGeRequestProposedAsOption } from './projectTwcGeRequestProposedAs.models';

export const apiRoutes = {
  getAllTwcGeRequestProposedAs: '/ProjectTwcGeRequests/ProposedAs/Options',
};

export const getAllTwcGeRequestProposedAsOptionsAsync = createGetOptionsFn<IProjectTwcGeRequestProposedAsOption>(
  apiRoutes.getAllTwcGeRequestProposedAs,
);
